import type { StrapiCypherpunkBlock } from "@/types/cypherpunk";

export const CYPH_TRACKER_SLUG = "cyph-tracker";

/** ISR / fetch cache for the cyph-tracker page and tracker APIs (15 minutes). */
export const CYPH_TRACKER_REVALIDATE_SECONDS = 15 * 60;

/** Fixed hero copy for the 5% progress card (layout strings, not metrics). */
export const CYPH_PROGRESS_HERO = {
  title: "Cypherpunk's progress to its 5% goal",
  subtitle: "Cypherpunk has publicly committed to acquiring 5% of all circulating ZEC",
  headlineSub: "of the way to the 5% network ownership goal",
} as const;

export const CYPH_CHART_LEAD_SUB = {
  cumulative: "Total ZEC accumulated since first purchase",
  network: "Cypherpunk's share of circulating ZEC supply · Goal: 5%",
} as const;

export const CYPH_WAFFLE_HERO = {
  title: "CYPHERPUNK'S SLICE OF THE ZCASH NETWORK",
  subtitle: "100 squares · 1% each · 5% network ownership target",
} as const;

export const CYPH_BUBBLE_CHART = {
  title: "Cypherpunk's Zcash Purchases & Reserve Value",
  subtitle:
    "Cypherpunk accumulates before disclosing, so bubbles often sit away from the spot price line.",
} as const;

/** Milestone markers on the progress bar (position = % of journey to 5% goal). */
export const CYPH_PROGRESS_MARKERS = [
  { left: "20%", label: "1%" },
  { left: "60%", label: "3%" },
  { left: "80%", label: "4%" },
] as const;

export type CyphTrackerSections = {
  chartLabels: [string, string, string];
  tableTitle: string;
  tableSubtext: string;
};

export function getCyphTrackerSections(
  blocks?: StrapiCypherpunkBlock[] | null,
): CyphTrackerSections | null {
  const [first, second, third, table] = blocks ?? [];
  if (
    !first?.subtitle?.trim() ||
    !second?.subtitle?.trim() ||
    !third?.subtitle?.trim() ||
    !table?.title?.trim() ||
    !table?.subtext?.trim()
  ) {
    return null;
  }

  return {
    chartLabels: [first.subtitle, second.subtitle, third.subtitle],
    tableTitle: table.title,
    tableSubtext: table.subtext,
  };
}
